export const EXAMINER_AUDIO_MAP: Record<string, string> = {
  departure_prep: '/audio/examiner/departure_prep.mp3',
  start_north: '/audio/examiner/start_north.mp3',
  tl_junction_60_turn_left: '/audio/examiner/tl_junction_60_turn_left.mp3',
  t_junction_north_ring: '/audio/examiner/t_junction_north_ring.mp3',
  ring_ne_corner: '/audio/examiner/ring_ne_corner.mp3',
  ring_nw_corner: '/audio/examiner/ring_nw_corner.mp3',
  ring_se_corner: '/audio/examiner/ring_se_corner.mp3',
  ring_sw_corner: '/audio/examiner/ring_sw_corner.mp3',
  south_ring_turn_north_rechts: '/audio/examiner/south_ring_turn_north_rechts.mp3',
  south_ring_turn_north_links: '/audio/examiner/south_ring_turn_north_links.mp3',
  south_ring_cruise: '/audio/examiner/south_ring_cruise.mp3',
  west_ring_south: '/audio/examiner/west_ring_south.mp3',
  east_ring_south: '/audio/examiner/east_ring_south.mp3',
  north_ring_east: '/audio/examiner/north_ring_east.mp3',
  north_ring_west: '/audio/examiner/north_ring_west.mp3',
  roundabout_from_south: '/audio/examiner/roundabout_from_south.mp3',
  approach_roundabout_from_w: '/audio/examiner/approach_roundabout_from_w.mp3',
  inside_roundabout: '/audio/examiner/inside_roundabout.mp3',
  res_cross_w_turn_south_links: '/audio/examiner/res_cross_w_turn_south_links.mp3',
  res_cross_w_turn_south_rechts: '/audio/examiner/res_cross_w_turn_south_rechts.mp3',
  res_cross_e_turn_south_links: '/audio/examiner/res_cross_e_turn_south_links.mp3',
  res_cross_e_turn_south_rechts: '/audio/examiner/res_cross_e_turn_south_rechts.mp3',
  res_30_west: '/audio/examiner/res_30_west.mp3',
  res_30_east: '/audio/examiner/res_30_east.mp3',
  cross_street_south: '/audio/examiner/cross_street_south.mp3',
  cross_street_approach_main_e_w_rechts: '/audio/examiner/cross_street_approach_main_e_w_rechts.mp3',
  cross_street_approach_main_e_w_links: '/audio/examiner/cross_street_approach_main_e_w_links.mp3',
  east_avenue_to_ring: '/audio/examiner/east_avenue_to_ring.mp3',
  east_ring_t_junction: '/audio/examiner/east_ring_t_junction.mp3',
  boulevard_south_heading_north: '/audio/examiner/boulevard_south_heading_north.mp3',
  ab_guidance: '/audio/examiner/ab_guidance.mp3',
  land_guidance: '/audio/examiner/land_guidance.mp3',
  laengsparken_start: '/audio/examiner/laengsparken_start.mp3',
  gefahrenbremsung_start: '/audio/examiner/gefahrenbremsung_start.mp3',
  gefahrenbremsung_stop: '/audio/examiner/gefahrenbremsung_stop.mp3',
  kreisverkehr_start: '/audio/examiner/kreisverkehr_start.mp3',
  ab_mission_start: '/audio/examiner/ab_mission_start.mp3',
  land_mission_start: '/audio/examiner/land_mission_start.mp3',
  engstelle_mission_start: '/audio/examiner/engstelle_mission_start.mp3',
  audiosystem_aktiv: '/audio/examiner/audiosystem_aktiv.mp3',
};

export const TEXT_TO_AUDIO_KEY: Record<string, string> = {
  'An der T-Kreuzung vor der Leitplanke bitte rechts abbiegen auf den Stadtring nach Osten.': 't_junction_north_ring',
  'An der nächsten Ampel links abbiegen in die 30er-Zone.': 'tl_junction_60_turn_left',
  'Gut. Fahren Sie bitte geradeaus auf der Hauptstraße nach Norden weiter.': 'start_north',
  'In etwa 60 Metern an der Ring-Ecke bitte rechts abbiegen auf den Ostring nach Süden.': 'ring_ne_corner',
  'In etwa 60 Metern an der Ring-Ecke bitte links abbiegen auf den Westring nach Süden.': 'ring_nw_corner',
  'In etwa 60 Metern an der Ring-Ecke bitte rechts abbiegen auf den Südring nach Westen.': 'ring_se_corner',
  'In etwa 60 Metern an der Ring-Ecke bitte links abbiegen auf den Südring nach Osten.': 'ring_sw_corner',
  'In etwa 50 Metern in den Kreisverkehr einfahren, zweite Ausfahrt geradeaus nehmen.': 'roundabout_from_south',
  'In den Kreisverkehr einfahren, zweite Ausfahrt geradeaus nehmen. Bei der Einfahrt nicht blinken.': 'approach_roundabout_from_w',
  'Jetzt rechten Blinker setzen, Schulterblick machen und an der nächsten Ausfahrt ausfahren.': 'inside_roundabout',
  'Sehr gut! Sie sind jetzt in der Tempo-30-Zone. Rechts-vor-Links beachten.': 'res_30_west',
  'Der Querstraße nach Süden folgen bis zur Hauptstraße.': 'cross_street_south',
  'Der Vorfahrtsstraße nach Osten folgen bis zum Stadtring.': 'east_avenue_to_ring',
  'An der T-Kreuzung bitte rechts abbiegen auf den Stadtring nach Süden.': 'east_ring_t_junction',
  'Der Hauptstraße nach Norden folgen Richtung Startpunkt.': 'boulevard_south_heading_north',
  'Sie befinden sich auf der Autobahn. Richtgeschwindigkeit 130 km/h. Rechtsfahrgebot beachten.': 'ab_guidance',
  'Sie fahren auf der Landstraße außerorts. Erlaubte Höchstgeschwindigkeit beträgt 100 km/h.': 'land_guidance',
  'Rückwärts in die markierte Parklücke einparken.': 'laengsparken_start',
  'Auf mindestens 30 km/h beschleunigen und auf Prüferkommando warten.': 'gefahrenbremsung_start',
  'GEFAHRENBREMSUNG! JETZT VOLLBREMSUNG!': 'gefahrenbremsung_stop',
  'In den Kreisverkehr einfahren und die zweite Ausfahrt nehmen.': 'kreisverkehr_start',
  'Sonderfahrt Autobahn. Zügig beschleunigen und einfädeln.': 'ab_mission_start',
  'Sonderfahrt Überlandfahrt. Außerorts bis 100 km/h.': 'land_mission_start',
  'Engstelle voraus. Blinker links und Gegenverkehr beachten.': 'engstelle_mission_start',
  'Audiosystem aktiv. Fahrprüfer Müller einsatzbereit.': 'audiosystem_aktiv',
};

export class AudioManager {
  private ctx: AudioContext | null = null;
  private isMuted: boolean = false;

  // Engine sound nodes: 3-oscillator synthesis (fundamental + 2nd harmonic + 4th harmonic for mobile speakers)
  private engineOsc1: OscillatorNode | null = null;
  private engineOsc2: OscillatorNode | null = null;
  private engineOsc3: OscillatorNode | null = null;
  private engineGain: GainNode | null = null;
  private engineGainMid: GainNode | null = null;
  private engineFilter: BiquadFilterNode | null = null;
  private engineFilterMid: BiquadFilterNode | null = null;
  private isEngineRunning: boolean = false;

  // Blinker sound state
  private blinkerInterval: number | null = null;
  private blinkerTock: boolean = false;

  // Voice synthesis & Garbage Collection retention
  private speechSynth: SpeechSynthesis | null = null;
  private germanVoice: SpeechSynthesisVoice | null = null;
  private activeUtterances: Set<any> = new Set();
  private voicesLoaded: boolean = false;
  private activeAudioElement: HTMLAudioElement | null = null;

  constructor() {
    if (typeof window !== 'undefined') {
      if ('speechSynthesis' in window) {
        this.speechSynth = window.speechSynthesis;
        this.initVoice();
      }

      // Automatically unlock audio and speech on ANY user touch or interaction
      const unlock = () => {
        this.primeSpeech();
        this.unlockAudio();
      };
      window.addEventListener('touchstart', unlock, { passive: true });
      window.addEventListener('touchend', unlock, { passive: true });
      window.addEventListener('pointerdown', unlock, { passive: true });
      window.addEventListener('click', unlock, { passive: true });
      window.addEventListener('keydown', unlock, { passive: true });
      if (typeof document !== 'undefined' && typeof document.addEventListener === 'function') {
        document.addEventListener('visibilitychange', () => {
          if (document.visibilityState === 'visible') {
            this.unlockAudio();
          }
        });
      }
    }
  }

  private initVoice() {
    if (!this.speechSynth) return;
    const loadVoices = () => {
      const voices = this.speechSynth?.getVoices() || [];
      if (voices.length > 0) {
        this.voicesLoaded = true;
        this.germanVoice =
          voices.find((v) => v.lang === 'de-DE' || v.lang === 'de_DE') ||
          voices.find((v) => v.lang.startsWith('de') || v.lang.includes('DE')) ||
          voices.find((v) => v.default) ||
          voices[0] ||
          null;
      }
    };
    loadVoices();
    if (this.speechSynth.onvoiceschanged !== undefined) {
      this.speechSynth.onvoiceschanged = loadVoices;
    }
    // Mobile WebViews sometimes delay voice loading without firing onvoiceschanged
    setTimeout(loadVoices, 300);
    setTimeout(loadVoices, 1000);
    setTimeout(loadVoices, 2500);
  }

  private isSpeechPrimed: boolean = false;

  /**
   * Universal audio unlock supporting Web Audio API resume, silent buffer kick, and SpeechSynthesis resume.
   * Safe to call repeatedly from any event handler or button click.
   */
  public async unlockAudio(): Promise<void> {
    const AudioCtx = window.AudioContext || (window as unknown as { webkitAudioContext: typeof AudioContext }).webkitAudioContext;
    if (!this.ctx && AudioCtx) {
      try {
        this.ctx = new AudioCtx();
        this.setupEngineSound();
      } catch (e) {
        console.warn('AudioContext creation error:', e);
      }
    }

    if (this.ctx && this.ctx.state === 'suspended') {
      try {
        await this.ctx.resume();
        // Play an inaudible 1-sample buffer to satisfy mobile browser/WebView audio unlocking policies
        const buffer = this.ctx.createBuffer(1, 1, 22050);
        const source = this.ctx.createBufferSource();
        source.buffer = buffer;
        source.connect(this.ctx.destination);
        source.start(0);
      } catch {
        // ignore
      }
    }

    // Ensure speech synthesis is not in paused state
    if (this.speechSynth && this.speechSynth.paused) {
      try {
        this.speechSynth.resume();
      } catch {
        // ignore
      }
    }

    if (!this.germanVoice) {
      this.initVoice();
    }
  }

  /**
   * Primes speech synthesis synchronously inside a direct user gesture handler (touch/click/key)
   * with a silent 0-volume utterance to unlock background speech on strict mobile WebViews.
   */
  public primeSpeech() {
    if (this.speechSynth && !this.isSpeechPrimed) {
      this.isSpeechPrimed = true;
      try {
        if (this.speechSynth.paused) {
          this.speechSynth.resume();
        }
        const prime = new SpeechSynthesisUtterance('');
        prime.volume = 0;
        this.speechSynth.speak(prime);
      } catch {
        // ignore
      }
    }
  }

  public init() {
    this.unlockAudio();
  }

  private setupEngineSound() {
    if (!this.ctx) return;

    // 3-Oscillator luxury Mercedes-Benz V8 / executive acoustic synthesis:
    // Osc 1: Deep baritone cylinder firing pulses (sawtooth, fundamental, warmly filtered)
    // Osc 2: Smooth acoustic engine body (triangle, 2nd harmonic roundness, warmly filtered)
    // Osc 3: Subtle mechanical combustion definition (sawtooth, 4th order, softly filtered for zero buzz)
    this.engineOsc1 = this.ctx.createOscillator();
    this.engineOsc2 = this.ctx.createOscillator();
    this.engineOsc3 = this.ctx.createOscillator();

    this.engineGain = this.ctx.createGain();
    this.engineGainMid = this.ctx.createGain();
    this.engineFilter = this.ctx.createBiquadFilter();
    this.engineFilterMid = this.ctx.createBiquadFilter();

    this.engineOsc1.type = 'sawtooth';
    this.engineOsc2.type = 'triangle';
    this.engineOsc3.type = 'sawtooth';

    // Deep sub-bass idle frequencies (24 Hz fundamental, 48 Hz 2nd harmonic, 96 Hz 4th harmonic)
    this.engineOsc1.frequency.setValueAtTime(24, this.ctx.currentTime);
    this.engineOsc2.frequency.setValueAtTime(48, this.ctx.currentTime);
    this.engineOsc3.frequency.setValueAtTime(96, this.ctx.currentTime);

    // Warm, velvety primary lowpass filter with gentle Q (eliminates whistling resonance)
    this.engineFilter.type = 'lowpass';
    this.engineFilter.frequency.setValueAtTime(125, this.ctx.currentTime);
    this.engineFilter.Q.setValueAtTime(0.9, this.ctx.currentTime);

    // Secondary smoothing filter for mid-frequencies (strips all harsh buzzy teeth from Osc 3)
    this.engineFilterMid.type = 'lowpass';
    this.engineFilterMid.frequency.setValueAtTime(180, this.ctx.currentTime);
    this.engineFilterMid.Q.setValueAtTime(0.7, this.ctx.currentTime);

    this.engineGain.gain.setValueAtTime(0.0, this.ctx.currentTime);
    this.engineGainMid.gain.setValueAtTime(0.0, this.ctx.currentTime);

    // Osc 1 & Osc 2 pass through primary lowpass filter
    this.engineOsc1.connect(this.engineFilter);
    this.engineOsc2.connect(this.engineFilter);
    this.engineFilter.connect(this.engineGain);
    this.engineGain.connect(this.ctx.destination);

    // Osc 3 passes through mid filter to eliminate harshness while retaining subtle acoustic definition
    this.engineOsc3.connect(this.engineFilterMid);
    this.engineFilterMid.connect(this.engineGainMid);
    this.engineGainMid.connect(this.ctx.destination);

    this.engineOsc1.start();
    this.engineOsc2.start();
    this.engineOsc3.start();
    this.isEngineRunning = true;
  }

  public updateEngine(rpm: number, throttle: number, isStalled: boolean) {
    if (!this.ctx || !this.isEngineRunning || this.isMuted) return;

    if (this.ctx.state === 'suspended') {
      this.ctx.resume().catch(() => {});
    }

    if (isStalled || rpm <= 0) {
      this.engineGain?.gain.setTargetAtTime(0.0, this.ctx.currentTime, 0.04);
      this.engineGainMid?.gain.setTargetAtTime(0.0, this.ctx.currentTime, 0.04);
      return;
    }

    const clampedRpm = Math.max(650, Math.min(6500, rpm));
    const rpmRatio = (clampedRpm - 650) / 5350; // 0.0 at idle (650 rpm), 1.0 at 6000 rpm

    // Deep, velvety Mercedes V8 / executive sedan harmonic fundamental
    // Idle purr ~23-25 Hz, cruising ~42-55 Hz, spirited acceleration ~75-88 Hz
    const baseFreq = 23 + rpmRatio * 62;

    // Acoustic lowpass frequency:
    // When standing still / idling (throttle=0), rolls off sharply at 110-125 Hz (soothing, deep purr, zero buzzing)
    // Under acceleration, the throttle opens the acoustic exhaust flap up to ~650 Hz (rich, throaty Mercedes growl)
    const throttleDamp = Math.pow(Math.max(0, Math.min(1, throttle)), 1.4);
    const filterFreq = 110 + rpmRatio * 260 + throttleDamp * 380;
    const midFilterFreq = 160 + rpmRatio * 240 + throttleDamp * 360;

    // Volume profile:
    // Whisper-quiet, calm idle (0.045 main, 0.008 mid) — completely relaxing and non-intrusive when not driving.
    // Dynamic baritone swell under throttle (up to 0.22 main, 0.07 mid) — deep, authoritative Mercedes power.
    const mainVol = 0.045 + throttleDamp * 0.14 + rpmRatio * 0.04;
    const midVol  = 0.008 + throttleDamp * 0.05 + rpmRatio * 0.02;

    this.engineOsc1?.frequency.setTargetAtTime(baseFreq, this.ctx.currentTime, 0.05);
    this.engineOsc2?.frequency.setTargetAtTime(baseFreq * 2.0, this.ctx.currentTime, 0.05);
    this.engineOsc3?.frequency.setTargetAtTime(baseFreq * 4.0, this.ctx.currentTime, 0.05);

    this.engineFilter?.frequency.setTargetAtTime(filterFreq, this.ctx.currentTime, 0.05);
    this.engineFilterMid?.frequency.setTargetAtTime(midFilterFreq, this.ctx.currentTime, 0.05);

    this.engineGain?.gain.setTargetAtTime(mainVol, this.ctx.currentTime, 0.05);
    this.engineGainMid?.gain.setTargetAtTime(midVol, this.ctx.currentTime, 0.05);
  }

  /**
   * Mercedes-Benz engine starter motor spin & deep ignition catch thrum
   */
  public playEngineStart() {
    if (!this.ctx || this.isMuted) return;
    if (this.ctx.state === 'suspended') this.ctx.resume().catch(() => {});
    const now = this.ctx.currentTime;

    // High-precision starter motor spin
    const starterOsc = this.ctx.createOscillator();
    const starterGain = this.ctx.createGain();
    starterOsc.type = 'triangle';
    starterOsc.frequency.setValueAtTime(110, now);
    starterOsc.frequency.exponentialRampToValueAtTime(180, now + 0.18);
    starterGain.gain.setValueAtTime(0.12, now);
    starterGain.gain.exponentialRampToValueAtTime(0.001, now + 0.22);
    starterOsc.connect(starterGain);
    starterGain.connect(this.ctx.destination);
    starterOsc.start(now);
    starterOsc.stop(now + 0.23);

    // Initial combustion catch / cylinder ignition thrum (deep bass punch)
    const kickOsc = this.ctx.createOscillator();
    const kickGain = this.ctx.createGain();
    kickOsc.type = 'sawtooth';
    kickOsc.frequency.setValueAtTime(55, now + 0.14);
    kickOsc.frequency.exponentialRampToValueAtTime(26, now + 0.40);
    kickGain.gain.setValueAtTime(0.001, now);
    kickGain.gain.setValueAtTime(0.18, now + 0.15);
    kickGain.gain.exponentialRampToValueAtTime(0.001, now + 0.42);
    kickOsc.connect(kickGain);
    kickGain.connect(this.ctx.destination);
    kickOsc.start(now + 0.14);
    kickOsc.stop(now + 0.43);
  }

  /**
   * Smooth executive engine shutdown spool down
   */
  public playEngineStop() {
    if (!this.ctx || this.isMuted) return;
    if (this.ctx.state === 'suspended') this.ctx.resume().catch(() => {});
    const now = this.ctx.currentTime;

    const stopOsc = this.ctx.createOscillator();
    const stopGain = this.ctx.createGain();
    stopOsc.type = 'triangle';
    stopOsc.frequency.setValueAtTime(32, now);
    stopOsc.frequency.exponentialRampToValueAtTime(12, now + 0.35);
    stopGain.gain.setValueAtTime(0.10, now);
    stopGain.gain.exponentialRampToValueAtTime(0.001, now + 0.35);
    stopOsc.connect(stopGain);
    stopGain.connect(this.ctx.destination);
    stopOsc.start(now);
    stopOsc.stop(now + 0.36);
  }

  public playBlinkerTick(state: 'left' | 'right' | 'hazard' | 'off') {
    if (state === 'off') {
      if (this.blinkerInterval) {
        clearInterval(this.blinkerInterval);
        this.blinkerInterval = null;
      }
      return;
    }

    if (this.blinkerInterval) return;

    const playClick = () => {
      if (!this.ctx || this.isMuted) return;
      if (this.ctx.state === 'suspended') this.ctx.resume().catch(() => {});

      // Realistic dual-tone mechanical relay click
      const osc = this.ctx.createOscillator();
      const gain = this.ctx.createGain();

      this.blinkerTock = !this.blinkerTock;
      const freq = this.blinkerTock ? 1450 : 1100;

      osc.type = 'triangle';
      osc.frequency.setValueAtTime(freq, this.ctx.currentTime);
      gain.gain.setValueAtTime(0.22, this.ctx.currentTime);
      gain.gain.exponentialRampToValueAtTime(0.001, this.ctx.currentTime + 0.045);

      osc.connect(gain);
      gain.connect(this.ctx.destination);

      osc.start();
      osc.stop(this.ctx.currentTime + 0.05);
    };

    playClick();
    this.blinkerInterval = window.setInterval(playClick, 420);
  }

  /**
   * Authentic German driving school radio intercom announcement chime (E5 -> A5).
   * Sounds immediately before examiner instructions to alert the student and wake audio.
   */
  public playRadioChime() {
    if (!this.ctx || this.isMuted) return;
    if (this.ctx.state === 'suspended') this.ctx.resume().catch(() => {});

    const now = this.ctx.currentTime;

    // Tone 1: E5 (659.25 Hz)
    const osc1 = this.ctx.createOscillator();
    const gain1 = this.ctx.createGain();
    osc1.type = 'triangle';
    osc1.frequency.setValueAtTime(659.25, now);
    gain1.gain.setValueAtTime(0.36, now);
    gain1.gain.exponentialRampToValueAtTime(0.001, now + 0.12);
    osc1.connect(gain1);
    gain1.connect(this.ctx.destination);
    osc1.start(now);
    osc1.stop(now + 0.13);

    // Tone 2: A5 (880.00 Hz)
    const osc2 = this.ctx.createOscillator();
    const gain2 = this.ctx.createGain();
    osc2.type = 'triangle';
    osc2.frequency.setValueAtTime(880.00, now + 0.10);
    gain2.gain.setValueAtTime(0.001, now);
    gain2.gain.setValueAtTime(0.38, now + 0.10);
    gain2.gain.exponentialRampToValueAtTime(0.001, now + 0.35);
    osc2.connect(gain2);
    gain2.connect(this.ctx.destination);
    osc2.start(now + 0.10);
    osc2.stop(now + 0.36);
  }

  public playBrakeSqueal(intensity: number) {
    if (!this.ctx || this.isMuted || intensity <= 0.1) return;

    const osc = this.ctx.createOscillator();
    const gain = this.ctx.createGain();

    osc.type = 'sawtooth';
    osc.frequency.setValueAtTime(2400 + Math.random() * 600, this.ctx.currentTime);
    gain.gain.setValueAtTime(Math.min(0.2, intensity * 0.18), this.ctx.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.001, this.ctx.currentTime + 0.12);

    osc.connect(gain);
    gain.connect(this.ctx.destination);

    osc.start();
    osc.stop(this.ctx.currentTime + 0.13);
  }

  public playEngineStall() {
    if (!this.ctx || this.isMuted) return;
    const osc = this.ctx.createOscillator();
    const gain = this.ctx.createGain();

    osc.type = 'sawtooth';
    osc.frequency.setValueAtTime(110, this.ctx.currentTime);
    osc.frequency.exponentialRampToValueAtTime(30, this.ctx.currentTime + 0.35);

    gain.gain.setValueAtTime(0.2, this.ctx.currentTime);
    gain.gain.linearRampToValueAtTime(0.001, this.ctx.currentTime + 0.35);

    osc.connect(gain);
    gain.connect(this.ctx.destination);

    osc.start();
    osc.stop(this.ctx.currentTime + 0.36);
  }

  public playHorn() {
    if (!this.ctx || this.isMuted) return;
    const osc1 = this.ctx.createOscillator();
    const osc2 = this.ctx.createOscillator();
    const gain = this.ctx.createGain();

    osc1.frequency.setValueAtTime(440, this.ctx.currentTime);
    osc2.frequency.setValueAtTime(370, this.ctx.currentTime);
    gain.gain.setValueAtTime(0.15, this.ctx.currentTime);
    gain.gain.linearRampToValueAtTime(0.001, this.ctx.currentTime + 0.4);

    osc1.connect(gain);
    osc2.connect(gain);
    gain.connect(this.ctx.destination);

    osc1.start();
    osc2.start();
    osc1.stop(this.ctx.currentTime + 0.4);
    osc2.stop(this.ctx.currentTime + 0.4);
  }

  public speakExaminer(text: string, onEnd?: () => void, audioKey?: string) {
    // 1. Always wake up audio pipeline and sound the radio intercom chime
    this.unlockAudio();
    this.playRadioChime();

    if (this.isMuted) {
      if (onEnd) onEnd();
      return;
    }

    // Stop any currently playing examiner audio clip
    if (this.activeAudioElement) {
      try {
        this.activeAudioElement.pause();
        this.activeAudioElement.currentTime = 0;
      } catch {}
      this.activeAudioElement = null;
    }

    // 2. If running inside the Android APK with native AndroidTTS bridge:
    const androidTts = typeof window !== 'undefined' ? (window as any).AndroidTTS : null;
    if (androidTts && typeof androidTts.speak === 'function') {
      try {
        androidTts.speak(text);
        if (onEnd) {
          const estimatedDurationMs = Math.max(2500, text.length * 80);
          setTimeout(onEnd, estimatedDurationMs);
        }
        return;
      } catch (err) {
        console.warn('AndroidTTS error, falling back:', err);
      }
    }

    // 3. Resolve pre-rendered audio key for Web & Desktop
    const resolvedKey = audioKey || TEXT_TO_AUDIO_KEY[text.trim()];
    const audioUrl = resolvedKey && EXAMINER_AUDIO_MAP[resolvedKey] ? EXAMINER_AUDIO_MAP[resolvedKey] : null;

    if (audioUrl && typeof Audio !== 'undefined') {
      try {
        const audio = new Audio(audioUrl);
        this.activeAudioElement = audio;
        audio.volume = 1.0;

        let finished = false;
        const handleEnd = () => {
          if (finished) return;
          finished = true;
          if (this.activeAudioElement === audio) {
            this.activeAudioElement = null;
          }
          if (onEnd) onEnd();
        };

        audio.onended = handleEnd;
        audio.onerror = (e) => {
          console.warn('Examiner audio clip playback failed, falling back to speech synthesis / TTS:', e);
          this.speakViaSynthesisOrTTS(text, onEnd);
        };

        // Play 100ms after chime has sounded
        setTimeout(() => {
          try {
            const playPromise = audio.play();
            if (playPromise && typeof playPromise.catch === 'function') {
              playPromise.catch((err) => {
                console.warn('Examiner audio.play() rejected:', err);
                this.speakViaSynthesisOrTTS(text, onEnd);
              });
            }
          } catch (err) {
            console.warn('Examiner audio.play exception:', err);
            this.speakViaSynthesisOrTTS(text, onEnd);
          }
        }, 100);
        return;
      } catch (err) {
        console.warn('Examiner Audio constructor failed:', err);
      }
    }

    // Unmapped text or Audio unavailable: speech synthesis or backend TTS proxy
    this.speakViaSynthesisOrTTS(text, onEnd);
  }

  private speakViaSynthesisOrTTS(text: string, onEnd?: () => void) {
    if (!this.speechSynth || this.isMuted) {
      if (onEnd) onEnd();
      return;
    }

    try {
      // If paused by Android or previous cancel, resume speech synthesis engine
      if (this.speechSynth.paused) {
        this.speechSynth.resume();
      }
      // Only cancel if actively speaking to prevent Chromium cancellation queue bugs
      if (this.speechSynth.speaking || this.speechSynth.pending) {
        this.speechSynth.cancel();
        if (this.speechSynth.paused) {
          this.speechSynth.resume();
        }
      }

      // Dynamic voice resolution (especially on Android where voices load asynchronously)
      const voices = this.speechSynth.getVoices() || [];
      if (!this.germanVoice && voices.length > 0) {
        this.germanVoice =
          voices.find((v) => v.lang === 'de-DE' || v.lang === 'de_DE') ||
          voices.find((v) => v.lang.startsWith('de') || v.lang.includes('DE')) ||
          voices.find((v) => v.default) ||
          voices[0] ||
          null;
      }

      const utterance = new SpeechSynthesisUtterance(text);
      utterance.lang = this.germanVoice ? this.germanVoice.lang : 'de-DE';
      if (this.germanVoice) {
        utterance.voice = this.germanVoice;
      }
      utterance.rate = 1.04; // Natural, brisk, prompt delivery so driver hears instructions well in advance
      utterance.pitch = 1.0;
      utterance.volume = 1.0;

      // Prevent Android Chromium V8 garbage collection bug (which cancels speech before it starts)
      const globalUtterances = ((window as any).__activeUtterances__ = (window as any).__activeUtterances__ || new Set());
      globalUtterances.add(utterance);
      this.activeUtterances.add(utterance);

      let finished = false;
      const cleanUp = () => {
        if (finished) return;
        finished = true;
        globalUtterances.delete(utterance);
        this.activeUtterances.delete(utterance);
        if (onEnd) onEnd();
      };

      utterance.onend = cleanUp;
      utterance.onerror = (e: any) => {
        // 'interrupted' or 'canceled' are standard lifecycle events when a new instruction supersedes the current speech
        if (e?.error === 'interrupted' || e?.error === 'canceled') {
          cleanUp();
          return;
        }
        console.warn('SpeechSynthesis error:', e);
        // If synthesis failed in browser (e.g. Linux Chromium "synthesis-failed"), stream from backend /api/tts
        if (typeof Audio !== 'undefined' && (e?.error === 'synthesis-failed' || e?.error === 'language-unavailable' || !this.germanVoice)) {
          this.playBackendTTS(text, cleanUp);
        } else {
          cleanUp();
        }
      };

      // Fallback timeout guard to prevent hangs if onend fails to fire on mobile
      const estimatedDurationMs = Math.max(3000, text.length * 90);
      setTimeout(cleanUp, estimatedDurationMs);

      // Speak promptly right after radio chime
      setTimeout(() => {
        try {
          if (this.speechSynth) {
            if (this.speechSynth.paused) this.speechSynth.resume();
            this.speechSynth.speak(utterance);
          }
        } catch (err) {
          console.warn('speechSynth.speak error:', err);
          if (typeof Audio !== 'undefined') {
            this.playBackendTTS(text, cleanUp);
          } else {
            cleanUp();
          }
        }
      }, 100);
    } catch (err) {
      console.warn('speakViaSynthesisOrTTS exception:', err);
      if (onEnd) onEnd();
    }
  }

  private playBackendTTS(text: string, onEnd?: () => void) {
    if (typeof Audio === 'undefined' || this.isMuted) {
      if (onEnd) onEnd();
      return;
    }
    try {
      const url = `/api/tts?text=${encodeURIComponent(text)}`;
      const audio = new Audio(url);
      this.activeAudioElement = audio;
      let finished = false;
      const finish = () => {
        if (finished) return;
        finished = true;
        if (this.activeAudioElement === audio) {
          this.activeAudioElement = null;
        }
        if (onEnd) onEnd();
      };
      audio.onended = finish;
      audio.onerror = () => {
        console.warn('Backend TTS audio playback failed for:', text);
        finish();
      };
      const p = audio.play();
      if (p && typeof p.catch === 'function') {
        p.catch(() => finish());
      }
    } catch (e) {
      console.warn('playBackendTTS exception:', e);
      if (onEnd) onEnd();
    }
  }

  /**
   * Diagnostic sound & speech test method for user verification in Settings or Cockpit.
   */
  public async testAudio(): Promise<void> {
    await this.unlockAudio();
    this.playRadioChime();
    setTimeout(() => {
      this.playBlinkerTick('left');
      setTimeout(() => {
        this.playBlinkerTick('off');
        this.speakExaminer('Audiosystem aktiv. Fahrprüfer Müller einsatzbereit.');
      }, 600);
    }, 200);
  }

  public playAlertBeep(isFatal: boolean = false) {
    if (!this.ctx || this.isMuted) return;
    const osc = this.ctx.createOscillator();
    const gain = this.ctx.createGain();

    osc.type = isFatal ? 'sawtooth' : 'sine';
    osc.frequency.setValueAtTime(isFatal ? 220 : 660, this.ctx.currentTime);
    gain.gain.setValueAtTime(0.15, this.ctx.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.001, this.ctx.currentTime + 0.25);

    osc.connect(gain);
    gain.connect(this.ctx.destination);

    osc.start();
    osc.stop(this.ctx.currentTime + 0.26);
  }

  public playCollisionSound(intensity: number = 0.5) {

    if (!this.ctx || this.isMuted) return;

    const clampedIntensity = Math.max(0.1, Math.min(1.0, intensity));
    const now = this.ctx.currentTime;
    const duration = 0.2 + clampedIntensity * 0.45;

    // 1. Low-frequency impact shock wave (chassis rumble)
    const subOsc = this.ctx.createOscillator();
    const subGain = this.ctx.createGain();
    subOsc.type = 'sawtooth';
    subOsc.frequency.setValueAtTime(140 * clampedIntensity, now);
    subOsc.frequency.exponentialRampToValueAtTime(25, now + duration);

    subGain.gain.setValueAtTime(0.35 * clampedIntensity, now);
    subGain.gain.exponentialRampToValueAtTime(0.001, now + duration);

    subOsc.connect(subGain);
    subGain.connect(this.ctx.destination);
    subOsc.start(now);
    subOsc.stop(now + duration + 0.05);

    // 2. White noise burst for crunch / bumper impact friction
    const bufferSize = Math.floor(this.ctx.sampleRate * duration);
    const noiseBuffer = this.ctx.createBuffer(1, bufferSize, this.ctx.sampleRate);
    const output = noiseBuffer.getChannelData(0);
    for (let i = 0; i < bufferSize; i++) {
      output[i] = Math.random() * 2 - 1;
    }

    const whiteNoise = this.ctx.createBufferSource();
    whiteNoise.buffer = noiseBuffer;

    const noiseFilter = this.ctx.createBiquadFilter();
    noiseFilter.type = 'bandpass';
    noiseFilter.frequency.setValueAtTime(300 + clampedIntensity * 800, now);
    noiseFilter.Q.setValueAtTime(1.5, now);

    const noiseGain = this.ctx.createGain();
    noiseGain.gain.setValueAtTime(0.4 * clampedIntensity, now);
    noiseGain.gain.exponentialRampToValueAtTime(0.001, now + duration * 0.8);

    whiteNoise.connect(noiseFilter);
    noiseFilter.connect(noiseGain);
    noiseGain.connect(this.ctx.destination);
    whiteNoise.start(now);
    whiteNoise.stop(now + duration);

    // 3. Metallic resonance ping for medium/high crashes (> 0.4 intensity)
    if (clampedIntensity > 0.35) {
      const metalOsc = this.ctx.createOscillator();
      const metalGain = this.ctx.createGain();
      metalOsc.type = 'triangle';
      metalOsc.frequency.setValueAtTime(680, now);
      metalOsc.frequency.exponentialRampToValueAtTime(180, now + duration * 0.5);

      metalGain.gain.setValueAtTime(0.25 * (clampedIntensity - 0.2), now);
      metalGain.gain.exponentialRampToValueAtTime(0.001, now + duration * 0.6);

      metalOsc.connect(metalGain);
      metalGain.connect(this.ctx.destination);
      metalOsc.start(now);
      metalOsc.stop(now + duration * 0.65);
    }
  }

  /**
   * Immediately stops any active examiner TTS speech or audio clip while keeping
   * vehicle engine sound and turn signal clicks unaffected.
   */
  public stopExaminerSpeech() {
    if (this.activeAudioElement) {
      try {
        this.activeAudioElement.pause();
        this.activeAudioElement.currentTime = 0;
      } catch {}
      this.activeAudioElement = null;
    }
    if (this.speechSynth) {
      try {
        if (this.speechSynth.speaking || this.speechSynth.pending) {
          this.speechSynth.cancel();
        }
      } catch {}
    }
    const androidTts = typeof window !== 'undefined' ? (window as any).AndroidTTS : null;
    if (androidTts && typeof androidTts.stop === 'function') {
      try {
        androidTts.stop();
      } catch {}
    }
  }

  public setMuted(muted: boolean) {
    this.isMuted = muted;
    if (muted) {
      if (this.ctx) {
        if (this.engineGain) this.engineGain.gain.setValueAtTime(0, this.ctx.currentTime);
        if (this.engineGainMid) this.engineGainMid.gain.setValueAtTime(0, this.ctx.currentTime);
      }
      this.stopExaminerSpeech();
    }
  }
}

